var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{staticClass:"code-btn",attrs:{"type":"primary","disabled":!!_vm.timer,"native-type":"button"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }